import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { dateFormatter, rupiah, formatDecimal } from 'utils/formatter';

class PointActivityRow extends Component {
  render() {
    const { pointActivity } = this.props;
    return (
      <tr onClick={this._onClickRow}>
        <td className="col-md-3">{dateFormatter(pointActivity.created_at)}</td>
        <td className="col-md-5">{pointActivity.outlet_name}</td>
        <td className="col-md-2 text-right">
          {this._saleFormatter(pointActivity.total_collected_amount)}
        </td>
        <td className="col-md-2 text-right">{this._getFormattedPoint()}</td>
      </tr>
    );
  }

  _onClickRow = () => {
    this.props.onClickRow({
      payment_type: this.props.pointActivity.payment_type.toLowerCase(),
      parent_payment_id: this.props.pointActivity.parent_payment_id,
    });
  };

  _saleFormatter = sale => {
    return sale < 0 ? `(${rupiah(-sale)})` : rupiah(sale);
  };

  _getFormattedPoint = () => {
    const { pointActivity } = this.props;
    const point = pointActivity.points + pointActivity.new_member_points;
    if (pointActivity.type.toUpperCase() === 'EARNING') {
      if (point >= 0) {
        return formatDecimal(point);
      }
      return `(${formatDecimal(-point)})`;
    }
    return `(${formatDecimal(point)})`;
  };
}

PointActivityRow.propTypes = {
  onClickRow: PropTypes.func,
  pointActivity: PropTypes.object,
};

export default PointActivityRow;
